import React, { useEffect, useState } from 'react';
import { Box, Button, Grid, Group } from '@mantine/core';
import axios from 'axios';
import ApiLinks from '../../Navlinks/ApiLinks';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import CustomMantineTable from '../../Utilities/CustomMantineTable';
import { EditRecord } from '../../Utilities/EditorDeleteRecords';


function Banner() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const user = useSelector((state) => state.auth.user);


    useEffect(() => {
        setLoading(true);
        axios
            .get(`${process.env.REACT_APP_API_URL}/${ApiLinks.Banner_list}/${user.compcode}`)
            .then((response) => {
                if (response.data.status) {
                    setData(response.data.data);
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            })
            .finally(() => {
                setLoading(false);
            });

    }, [user.compcode]);



    const columns = [
        {
            id: 'actions',
            header: 'Actions',
            size: '100',
            Cell: ({ row }) => (
                <Group spacing="xs">
                    <EditRecord
                        id={row.original.id}
                        route="/dashboard/banneradd"
                    />
                </Group>
            ),
        },
        {
            accessorKey: 'name',
            header: 'Name',
        },
        {
            accessorKey: 'primarytext',
            header: 'Primarytext',
        },
        {
            accessorKey: 'secondarytext',
            header: 'Secondarytext',
        },
        {
            accessorKey: 'bannerimage',
            header: 'bannerimage',
            Cell: ({ cell }) => {
                const photoPath = cell.getValue();
                const imageUrl = `${process.env.REACT_APP_IMG_URL}/${photoPath}`;
                return (
                    <a href={imageUrl} target="_blank" rel="noopener noreferrer">
                        <img
                            src={imageUrl}
                            alt="Amenity"
                            style={{ width: 'auto', height: '50px', objectFit: 'cover' }}
                        />
                    </a>
                );
            },
        },



    ];

    return (
        <Box>


            <Group position="apart" mb="md">
                <h2>Banner List</h2>

            </Group>
            <Grid justify="center">
                <Grid.Col span={10}>
                    <CustomMantineTable columns={columns} data={data} loading={loading} />
                </Grid.Col>
            </Grid>
        </Box>

    );
}

export default Banner;
